module.exports = __webpack_public_path__ + "media/images/countryrect/ua-67397d8c2f19fddc3cf10613c7d9219e.svg";